const carouselItems = [
  {
    id: 1,
    title: '2026夏季日剧大赏',
    desc: '盘点本季最值得追的十部日剧，从治愈系到硬核悬疑，总有一部适合你。',
    tag: '专题策划',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20vibes%20Japanese%20drama%20aesthetic%20with%20bright%20sunlight%20through%20leaves%2C%20youthful%20energy%2C%20warm%20green%20and%20golden%20tones%2C%20Japanese%20television%20drama%20poster%20style%2C%20nostalgic%20summer%20mood&width=800&height=500&seq=carousel-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '韩剧OST经典回顾',
    desc: '那些年让我们单曲循环的韩剧原声带，每一首都承载着难忘的剧情回忆。',
    tag: '音乐专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20music%20and%20drama%20scene%20with%20vinyl%20records%20and%20soft%20golden%20lighting%2C%20Korean%20drama%20OST%20aesthetic%2C%20romantic%20atmosphere%2C%20vintage%20tones%2C%20emotional%20storytelling%20visual&width=800&height=500&seq=carousel-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '高分悬疑日剧指南',
    desc: '推理迷不容错过的日系悬疑佳作，反转不断让你停不下来。',
    tag: '类型推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20suspenseful%20atmosphere%20with%20dark%20urban%20cityscape%20and%20dramatic%20shadows%2C%20Japanese%20mystery%20drama%20aesthetic%2C%20rain%20on%20window%2C%20moody%20blue%20and%20gray%20tones%2C%20cinematic%20noir%20style&width=800&height=500&seq=carousel-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '治愈系日剧精选',
    desc: '温暖人心的日式治愈剧集，在忙碌生活中给你一个温柔的拥抱。',
    tag: '类型推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20cozy%20Japanese%20countryside%20scene%20with%20warm%20sunlight%2C%20wooden%20house%20and%20garden%2C%20healing%20atmosphere%2C%20soft%20pastel%20colors%2C%20Japanese%20slice%20of%20life%20drama%20aesthetic%2C%20gentle%20natural%20light&width=800&height=500&seq=carousel-card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '韩剧古装史诗巨作',
    desc: '宏大的历史背景，精美的服饰场景，带你穿越时空感受朝鲜时代的爱恨情仇。',
    tag: '专题策划',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20historical%20palace%20scene%20with%20traditional%20hanbok%20costumes%2C%20dramatic%20golden%20sunset%20lighting%2C%20ancient%20architecture%2C%20epic%20cinematic%20composition%2C%20Korean%20sageuk%20drama%20aesthetic%2C%20majestic%20atmosphere&width=800&height=500&seq=carousel-card-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            专题推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            精心策划的专题内容，带你深度探索日韩影视的精彩世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/50 transition-all duration-200 cursor-pointer ${
                item.id <= 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-black/60 text-white text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}